export default __webpack_public_path__ + "static/media/12.39634726.png";